import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const faqs = [
    {
        id: 1,
        question: "How does Nuviosites work?",
        answer:
            "Nuviosites offers a comprehensive range of Web Development, Ai Automations, Digital solutions, helping clients establish and enhance their online presence through tailored strategies and expert services.",
    },
    {
        id: 2,
        question: "What services do Nuviosites offer?",
        answer:
            "We provide services like Web Development, AI Automations, AI Agents, Website Design, Web Branding, digital marketing, and custom web applications, customized to meet client needs.",
    },
    {
        id: 3,
        question: "What's the average project duration at Nuviosites?",
        answer:
            "Project durations depend on complexity, ranging from 2-4 weeks for basic websites to several weeks for advanced solutions like custom web applications or branding campaigns.",
    },
    {
        id: 4,
        question: "Is an advance payment required before starting a project?",
        answer:
            "Yes, we require an advance payment of 40% of the project value to allocate necessary resources and begin work efficiently.",
    },
    {
        id: 5,
        question: "Do you offer refunds?",
        answer:
            "Refunds are provided only for work not yet commenced. Once a project starts, refunds are not applicable. For more details, contact nuviosites@gmail.com.",
    },
    {
        id: 6,
        question: "What happens if I miss a payment deadline?",
        answer:
            "Missing a payment deadline may result in temporary suspension of services and a hold on project ownership until dues are cleared. Timely payments are recommended to avoid delays.",
    },
    {
        id: 7,
        question: "Can the company cancel a project?",
        answer:
            "In rare cases, we may cancel a project due to non-cooperation or excessive scope changes. Clients will be notified immediately, and refunds for incomplete work will be processed based on progress.",
    },
    {
        id: 8,
        question: "How long will it take to get an estimate from you?",
        answer:
            "We typically provide a detailed estimate within 24 hours after receiving all necessary project details.",
    },
];

const FAQ: React.FC = () => {
    const [expandedFAQ, setExpandedFAQ] = useState<number | null>(null);

    const toggleFAQ = (id: number) => {
        setExpandedFAQ(expandedFAQ === id ? null : id);
    };

    return (
        <section
            id="faq"
            className=" bg-white flex items-center justify-center relative"
        >
            <div className="w-full px-4 sm:px-6 md:px-12 lg:px-16 xl:px-24 pt-32 pb-8 sm:pt-40 sm:pb-12 md:py-12 lg:py-16">

                {/* Heading */}
                <div className="mb-8 sm:mb-10 lg:mb-16">
                    <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-[6.5rem] xl:text-[7.5rem] font-light tracking-[-0.04em] leading-none text-black">
                        Frequently Asked Questions
                    </h2>
                </div>

                {/* FAQ Items */}
                <div className="max-w-5xl">
                    {faqs.map((faq) => (
                        <div
                            key={faq.id}
                            className="border-b border-black/10 py-6 sm:py-8"
                        >
                            <button
                                onClick={() => toggleFAQ(faq.id)}
                                className="w-full flex justify-between items-start gap-4 text-left focus:outline-none cursor-pointer"
                            >
                                <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl 
                  font-thin text-black leading-snug flex-1">
                                    {faq.question}
                                </h3>

                                <div className="flex-shrink-0">
                                    {expandedFAQ === faq.id ? (
                                        <Minus className="h-6 sm:h-7 lg:h-8 w-6 sm:w-7 lg:w-8 
                      text-black/70" />
                                    ) : (
                                        <Plus className="h-6 sm:h-7 lg:h-8 w-6 sm:w-7 lg:w-8 
                      text-black/70" />
                                    )}
                                </div>
                            </button>

                            {expandedFAQ === faq.id && (
                                <p className="mt-4 text-black font-normal text-base sm:text-lg lg:text-lg 
                  font-light leading-relaxed">
                                    {faq.answer}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
